var Operator = {

     Unknown           : 'Unknown'
    ,Equal             : 'Equal' 
    ,GreaterThan       : 'GreaterThan' 
    ,GreaterThanOrEqual: 'GreaterThanOrEqual' 
    ,LessThan          : 'LessThan' 
    ,LessThanOrEqual   : 'LessThanOrEqual' 
    ,Between           : 'Between' 
    ,Matches           : 'Matches' 
    ,AnyOf             : 'AnyOf' 
    ,AllOf             : 'AllOf' 
    ,Yes               : 'Yes' 
    ,No                : 'No' 
    ,Answered          : 'Answered' 
}

module.exports = Operator;